import { useMemo } from "react"
import _ from "lodash"

import { PostData } from "providers/venue/types"
import { useGetPosts } from "providers/venue/modules/data/posts/useGetPosts"

export const usePost = (categoryReference: string) => {
  const { data, isFetched } = useGetPosts()

  const filteredPosts = useMemo(() => {
    if (!data) return []

    return data.filter((post: PostData) => {
      const postCategoryReference = _.get(
        post,
        "properties.category.properties.reference"
      )
      // TODO: Deprecate `postType`. It will be removed later.
      const postType = _.get(post, "properties.type")
      return (
        postCategoryReference === categoryReference ||
        postCategoryReference === postType
      )
    })
  }, [data, categoryReference])

  const hasData = _.size(filteredPosts) > 0

  return {
    hasData,
    postData: filteredPosts,
    isFetched,
  }
}
